import { render, staticRenderFns } from "./ListWidgetItemForm.vue?vue&type=template&id=1d86cb14&scoped=true"
import script from "./ListWidgetItemForm.vue?vue&type=script&lang=js"
export * from "./ListWidgetItemForm.vue?vue&type=script&lang=js"
import style0 from "./ListWidgetItemForm.vue?vue&type=style&index=0&id=1d86cb14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d86cb14",
  null
  
)

export default component.exports